import parseISO from "date-fns/parseISO";
import ProjectMember from "@/models/project-member";

export class FolderEntry {
  // TODO どうせならidにしたい
  entryId?: string | number;
  parentFolderId: string | number = 0;
  kind: "folder" | "file";
  name: string = "";
  image: string = "";
  updated: Date = new Date();
  readMembers?: ProjectMember[] = [];
  startDate?: string = "";
  endDate?: string = "";
  isEstimateTemplate?: boolean = undefined;
  isEstimate?: boolean = undefined;
  isTemplate?: boolean = undefined;

  public constructor(params: FolderEntry) {
    if (params.entryId) this.entryId = params.entryId;
    if (params.parentFolderId) this.parentFolderId = params.parentFolderId;
    this.kind = params.kind;
    if (params.name) this.name = params.name;
    if (params.image) this.image = params.image;
    if (params.updated) this.updated = params.updated;
    if (params.readMembers) this.readMembers = params.readMembers;
    if (params.startDate) this.startDate = params.startDate;
    if (params.endDate) this.endDate = params.endDate;
  }

  public static create(data: any): FolderEntry {
    return new FolderEntry({
      ...data,
      updated: parseISO(data.updated)
    });
  }
}

export interface Breadcrumb {
  id: number;
  name: string;
}
